import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Unidades',
    path: '/warehouse/unitTypes',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
